(function () {
  function showFallback(bridge, appSection) {
    var fallback = bridge.querySelector('[data-b2h-forms-fallback]');
    var slot = bridge.querySelector('[data-b2h-forms-slot]');
    if (!fallback || !slot) return;

    fallback.hidden = false;
    fallback.removeAttribute('inert');
    slot.hidden = true;
    if (appSection) appSection.hidden = true;
    bridge.dataset.b2hFormsOwner = 'fallback';
  }

  function hasInteractiveForm(appRoot, retainSuccess) {
    if (appRoot.querySelector('form, input:not([type="hidden"]), select, textarea, button')) return true;
    var embed = appRoot.querySelector('shopify-forms-embed');
    if (retainSuccess && embed && embed.shadowRoot && embed.shadowRoot.querySelector('[data-current-step="success"]')) return true;
    return Boolean(embed && embed.shadowRoot && embed.shadowRoot.querySelector(
      'form, input:not([type="hidden"]), select, textarea, button[type="submit"]'
    ));
  }

  function showShopifyForms(bridge, appRoot, appSection) {
    var fallback = bridge.querySelector('[data-b2h-forms-fallback]');
    var slot = bridge.querySelector('[data-b2h-forms-slot]');
    var appBlock = appRoot.closest('.shopify-app-block') || appRoot.parentElement;
    if (!fallback || !slot || !appBlock) return;

    if (appBlock.parentElement !== slot) slot.appendChild(appBlock);
    fallback.hidden = true;
    fallback.setAttribute('inert', '');
    slot.hidden = false;
    if (appSection) appSection.hidden = true;
    bridge.dataset.b2hFormsOwner = 'shopify-forms';
  }

  function initBridge(bridge) {
    if (bridge.dataset.b2hFormsBridgeReady === 'true') return;

    var formId = bridge.dataset.b2hFormsId;
    if (!formId) return;
    var appRoot = document.querySelector('[data-forms-id="forms-root-' + formId + '"]');
    if (!appRoot) return;

    var appSection = appRoot.closest('.shopify-section--apps');
    bridge.dataset.b2hFormsBridgeReady = 'true';
    function syncOwner() {
      if (hasInteractiveForm(appRoot, bridge.hasAttribute('data-b2h-forms-retain-success'))) {
        showShopifyForms(bridge, appRoot, appSection);
      } else {
        showFallback(bridge, appSection);
      }
      if (bridge.hasAttribute('data-b2h-forms-observe-state')) {
        var embed = appRoot.querySelector('shopify-forms-embed');
        var successRoot = embed && embed.shadowRoot ? embed.shadowRoot : appRoot;
        var state = bridge.dataset.b2hFormsOwner === 'shopify-forms'
          ? (successRoot.querySelector('[data-current-step="success"]') ? 'success' : 'ready')
          : 'fallback';
        if (bridge.dataset.b2hFormsState !== state) {
          bridge.dataset.b2hFormsState = state;
          bridge.dispatchEvent(new CustomEvent('b2h:forms:state', { bubbles: true, detail: { state: state } }));
        }
      }
    }

    syncOwner();
    var observer = new MutationObserver(syncOwner);
    observer.observe(appRoot, { childList: true, subtree: true });
    var readinessInterval = window.setInterval(function () {
      if (!bridge.isConnected || !appRoot.isConnected) {
        window.clearInterval(readinessInterval);
        observer.disconnect();
        bridge.removeAttribute('data-b2h-forms-bridge-ready');
        return;
      }
      syncOwner();
    }, 250);
  }

  function init() {
    document.querySelectorAll('[data-b2h-forms-bridge]').forEach(initBridge);
  }

  function startDiscovery() {
    var attempts = 0;
    var discoveryInterval = window.setInterval(function () {
      attempts += 1;
      init();
      var pending = document.querySelector('[data-b2h-forms-bridge]:not([data-b2h-forms-bridge-ready="true"])');
      if (!pending || attempts >= 80) window.clearInterval(discoveryInterval);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      startDiscovery();
    });
  } else {
    init();
    startDiscovery();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    startDiscovery();
  });
})();
